var videoID = "";
var modalID = "";
var videoType = "";
var lightboxModal;

const closeButton = document.querySelector(".close-modal");
var lightboxHTML = "";


// open lightbox
$(".show-modal").click(function(){
  
  //get video id
  videoID = $(this).attr('data-video-id');
  //get modal element id
  videoType = $(this).attr("data-video-type");
  
  //define lightbox HTML based on video id and video type
  if (videoType == 'youtube'){
    lightboxHTML = '<iframe src="https://www.youtube.com/embed/' + videoID + '?enablejsapi=1" class="js-youtube" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
  } else {
    lightboxHTML = '<iframe src="https://player.vimeo.com/video/'+ videoID + ' class="js-vimeo" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
  }

  
  //add iframe to lightbox modal
  $(".lightbox-modal").eq(0).append(lightboxHTML);
  $('.video-lightbox-wrapper').eq(0).css("display","flex");
  $('.video-lightbox-wrapper').eq(0).css("opacity","1");
  $('body').addClass("no-scroll");
});

// close lightbox
$(".close-modal").click(function(){ closeModal();});
$(".lightbox-bg").click(function(){ closeModal();});

function closeModal(){
  $('.video-lightbox-wrapper').eq(0).css("opacity","0");
  setTimeout(function(){
    $('.video-lightbox-wrapper').css("display","none");
  },500);
  
  $('.lightbox-modal iframe').remove();
  $('body').removeClass("no-scroll");
}